/**
 * Field contract for rent booking receipt list filters.
 * Category is a custom control that writes `type` / `mode` into list filters.
 */
export const RENT_BOOKING_RECEIPT_FILTER_FIELDS = [
  {
    source: "type",
    label: "Receipt category",
    kind: "category" as const,
    relatedSources: ["type", "mode"] as const,
  },
  { source: "q", label: "Search", kind: "text" as const },
  { source: "start", label: "From", kind: "date" as const },
  { source: "end", label: "To", kind: "date" as const },
] as const;

export const RENT_BOOKING_RECEIPT_FILTER_SOURCES = ["type", "mode", "q", "start", "end"] as const;
